<template>
  <v-dialog v-model="opened" width="800">
    <v-card>
      <v-layout class="pt-2">
        <v-spacer />
        <v-btn
          small
          flat
          fab
          class="my-0 white text-capitalize"
          @click="$emit('update:opened', false)"
        >
          <v-icon size="20"> cancel </v-icon>
        </v-btn>
      </v-layout>
      <v-card-title class="text-xs-center pt-0" align-center justify-center>
        <v-layout column>
          <v-flex justify-center class="body-1 mb-1">
            <v-chip
              class="primary--text caption font-weight-bold"
              small
              label
              disabled
              style="background-color: #e8eefc; font-weight: 900"
            >
              Add-On
            </v-chip>
          </v-flex>
          <v-flex justify-center class="title font-weight-bold">
            Benefits of My Cloud
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout align-center justify-start>
          <v-layout wrap>
            <v-flex xs5>
              <!-- <v-layout column justify-space-between> -->
              <v-layout class="primary--text display-1 font-weight-strong mb-1">
                0{{ benefitIndex + 1 }}
              </v-layout>
              <v-layout class="subheading font-weight-bold text-xs-left">
                {{ benefits[benefitIndex].title }}
              </v-layout>
              <v-layout
                class="caption text-xs-left mt-2 pr-4 mb-4"
                style="height: 120px"
              >
                {{ benefits[benefitIndex].description }}
              </v-layout>
              <v-layout align-center justify-start>
                <v-btn
                  class="primary--text ml-0"
                  flat
                  fab
                  small
                  @click="previousBenefit"
                  style="background-color: #c8d7f9; border-radius: 30px"
                >
                  <i class="material-icons-outlined" style="color: black">
                    arrow_back
                  </i>
                </v-btn>
                <v-btn
                  class="primary--text"
                  flat
                  fab
                  small
                  @click="nextBenefit"
                  style="background-color: #c8d7f9; border-radius: 30px"
                >
                  <i class="material-icons-outlined" style="color: black">
                    arrow_forward
                  </i>
                </v-btn>
              </v-layout>
              <!-- </v-layout> -->
            </v-flex>
            <v-flex xs7>
              <img
                src="@/assets/cloud.jpeg"
                width="100%"
                style="border-radius: 12px"
              />
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-divider class="mt-4" />
      <v-card-actions class="ma-2">
        <v-btn class="text-none" flat>
          Learn more about My Cloud
          <v-icon size="18">call_made</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn class="primary text-none" flat>
          Schedule a Call to Unlock
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, reactive, toRefs } from '@vue/composition-api';

export default {
  props: {
    opened: Boolean,
  },
  setup(props) {
    let benefitIndex = ref(0);

    const benefits = [
      {
        title: 'Access your work anywhere, anytime',
        description:
          'One of the best advantages about migrating to the cloud is that you’ll be independent from your Windows computer. Want to access your work from an iPad? No problem. Mac computer? Absolutely. This is an especially strong case for accountants who prefer to use Apple devices.',
      },
      {
        title: 'More secure, cloud-based backup',
        description:
          "Many firms currently back up files locally to their desktops, which means if there's a break-in, a fire or other incident at the office, they’d be in huge trouble. Most cloud providers offer secure, cloud-based data storage as the default option so file security would be one less thing to worry about.",
      },
      {
        title: 'Built-in audit trails',
        description:
          "For each employee and contractor who accesses your tax software, you can ask the cloud provider to generate a report for you or see if there's any suspicious activity.",
      },
      {
        title: 'Remote working without hiring IT',
        description:
          'By moving all the essential software into the cloud, you and your team can work remotely – without hiring a technician to handle any setup.',
      },
      {
        title: 'Better collaboration + information hand-off',
        description:
          'Cloud hosting makes team collaboration much easier – it enables seamless internal hand-off of information between teammates and contractors.',
      },
      {
        title: 'Always-on customer support',
        description:
          'Moving your operations onto our cloud-based platform makes troubleshooting a breeze for you and your clients. We have a live chat box and email through which we can address any issues promptly.',
      },
    ];

    function previousBenefit() {
      if (benefitIndex.value === 0) {
        benefitIndex.value = benefits.length - 1;
      } else {
        benefitIndex.value = benefitIndex.value - 1;
      }
    }

    function nextBenefit() {
      if (benefitIndex.value + 1 === benefits.length) {
        benefitIndex.value = 0;
      } else {
        benefitIndex.value = benefitIndex.value + 1;
      }
    }

    return {
      benefits,
      benefitIndex,
      previousBenefit,
      nextBenefit,
    };
  },
};
</script>
